<template>
        <div class="policy-file-item-content">
          <div class="policy-file-item-title">{{ record.name }}</div>
          <div class="policy-file-item-tags with-row-gap">
            <van-tag v-for="(item,index) in record.policyTopic" :key="item" :class="'tag_'+index">
              {{ item }}
            </van-tag>
          </div>
          <div class="policy-content">
            <div v-html="record.coreContent"></div>
          </div>
        </div>
</template>
<script>
import { defineComponent,reactive,toRefs } from 'vue'
import moment from 'moment'
import { clickUrl } from '@/utils'

export default defineComponent({
    components: {moment},
    props:{
        record: {}
    },
    setup() {
        const state = reactive({

        })

        const list = []

    function declare(item){
        item.status = 1
    }
    function formatDate(time){
        return time ? moment(time).format('YYYY-MM-DD') : ''
    }
    
        
    return {...toRefs(state),list,formatDate,declare}
    },
})
</script>
<style lang="scss">
 
</style>